$(document).on('turbolinks:load', function() {
  $('#scheduled-days-table').dataTable({
    "processing": true,
    "serverSide": true,
    "ajax": {
      "url": $('#scheduled-days-table').data('source')
    },
    "pagingType": "full_numbers",
    "columns": [
      {"data": "job"},
      {"data": "department"},
      {"data": "date_scheduled"}, 
      {"data": "start_time"},
      {"data": "end_time"}, 
      {"data": "ops"},
    ], 
    columnDefs: [{ "orderable": false, "targets": 5 }, { "width": "5%", "targets": 5 },{ "className": 'dt-center', "targets": 5 }]
  });
});